
// considers HTML-only/whitespace-only strings as empty
const isEmptyishHtml = (s) => {
	if (typeof s !== "string") return false
	const stripped = s
		.replace(/<[^>]*>/g, "")          // remove tags
		.replace(/&nbsp;|&#160;/gi, " ")   // collapse hard spaces
		.trim()
	return stripped.length === 0
}

// remove empty-ish values from an object *in place*
const pruneEmptyishHtml = (value) => {
	if (Array.isArray(value)) {
		value.forEach(pruneEmptyishHtml)
		return value
	}
	if (value && typeof value === "object") {
		Object.keys(value).forEach((k) => {
			const v = value[k]
			if (isEmptyishHtml(v)) {
				// delete key so defaults can supply the value
				delete value[k]
			} else if (v && typeof v === "object") {
				pruneEmptyishHtml(v)
				// if you also want to drop empty objects, uncomment:
				// if (!Array.isArray(v) && Object.keys(v).length === 0) delete value[k]
			}
		})
		return value
	}
	return value
}

const fmt2Dec = (number) => {
	return (Math.round(number * 100) / 100).toFixed(2);
}

function classNames(...classes) {
	return classes.filter(Boolean)
		.join(' ')
}

export {
	pruneEmptyishHtml,
	isEmptyishHtml,
	fmt2Dec,
	classNames
}